import { NAV_LINKS, CONTACT, scrollToId } from "@/constants/site";
import { useSiteImage } from "@/context/ImagesContext";

const Footer = () => {
  const logoSrc = useSiteImage("logo", null);

  return (
    <footer data-testid="footer-section" className="bg-espresso text-cream py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {logoSrc && (
          <img
            data-testid="footer-logo-image"
            src={logoSrc}
            alt="Masthare Estate logo"
            className="h-14 w-auto object-contain mb-8"
          />
        )}
        {/* LOGO SPOT: uploading a logo via /manage-images shows it above automatically */}
        <p className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-snug max-w-3xl">
          Masthare Estate.
          <span className="italic text-gold"> Rooted in heritage. </span>
          Grown with patience.
        </p>

        <div className="mt-12 pt-8 border-t border-cream/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Footer">
            {NAV_LINKS.map((link) => (
              <button
                key={link.target}
                data-testid={`footer-link-${link.target}`}
                onClick={() => scrollToId(link.target)}
                className="text-xs tracking-[0.2em] uppercase text-cream/60 hover:text-gold transition-colors"
              >
                {link.label}
              </button>
            ))}
          </nav>
          <p className="font-mono-alt text-[10px] tracking-[0.25em] uppercase text-cream/40">
            © {new Date().getFullYear()} Masthare Estate · {CONTACT.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
